var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGroup10(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 30,
    viewBox: "0 0 34 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0307 29.043V7.72461L1.25198 8.39816C1.24812 8.39816 1.24433 8.39816 1.24048 8.39816V28.8411C1.24048 28.9526 1.33091 29.043 1.44245 29.043H11.0307Z",
    fill: "#BEB9DD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.2028 8.39816L22.4241 7.72461V29.043H32.0123C32.1238 29.043 32.2143 28.9526 32.2143 28.8411V8.39816C32.2104 8.39816 32.2066 8.40006 32.2028 8.39816Z",
    fill: "#BEB9DD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1023 5.90046V8.39949H32.204H32.2155C32.8982 8.39374 33.4563 7.835 33.4563 7.14994C33.4563 6.46299 32.8925 5.90039 32.204 5.90039H23.1023V5.90046Z",
    fill: "#EB5468"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.24048 9.95987H8.19433C9.19538 9.95987 9.0247 10.4803 9.0247 11.4907V29.0432H10.3537V8.39844H1.25198C1.24812 8.39844 1.24433 8.39844 1.24048 8.39844V9.95987Z",
    fill: "#A7A2D3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.7855 7.14994C31.7855 7.835 31.2274 8.39374 30.5447 8.39949H32.2036H32.2151C32.8978 8.39374 33.4559 7.835 33.4559 7.14994C33.4559 6.46299 32.892 5.90039 32.2036 5.90039H30.5332C31.2217 5.90046 31.7855 6.46299 31.7855 7.14994Z",
    fill: "#E5384F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.2028 8.39844H30.544H23.1011V9.95987H29.7251C30.3004 9.95987 30.544 9.94837 30.544 10.5779V29.0433H32.0124C32.1239 29.0433 32.2144 28.9529 32.2144 28.8413V8.39844C32.2105 8.39844 32.2067 8.39844 32.2028 8.39844Z",
    fill: "#A7A2D3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1007 2.49778V29.0421H20.4297V21.3513H13.025V29.0421H10.354V2.49778L16.5369 1.73242L23.1007 2.49778Z",
    fill: "#F9F7F8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.53589 17.3105H8.058V20.1865H3.53589V17.3105Z",
    fill: "#B1E4F9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.53613 11.2656H8.05825V14.1416H3.53613V11.2656Z",
    fill: "#B1E4F9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.3943 11.2656H29.9183V14.1416H25.3943V11.2656Z",
    fill: "#B1E4F9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.3948 17.3105H29.9188V20.1865H25.3948V17.3105Z",
    fill: "#B1E4F9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.3948 23.3574H29.9188V26.2315H25.3948V23.3574Z",
    fill: "#B1E4F9"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.53662 23.3574H8.05874V26.2315H3.53662V23.3574Z",
    fill: "#B1E4F9"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.53613 11.2656H8.05825V12.3295H3.53613V11.2656Z",
    fill: "#75CEF8"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.53589 17.3105H8.058V18.3745H3.53589V17.3105Z",
    fill: "#75CEF8"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.53662 23.3574H8.05874V24.4194H3.53662V23.3574Z",
    fill: "#75CEF8"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.3948 23.3574H29.9188V24.4194H25.3948V23.3574Z",
    fill: "#75CEF8"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.3948 17.3105H29.9188V18.3745H25.3948V17.3105Z",
    fill: "#75CEF8"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.3943 11.2656H29.9183V12.3295H25.3943V11.2656Z",
    fill: "#75CEF8"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9189 20.6943H25.395C25.1161 20.6943 24.8901 20.4683 24.8901 20.1894V17.3134C24.8901 17.0346 25.1162 16.8086 25.395 16.8086H29.9189C30.1978 16.8086 30.4238 17.0346 30.4238 17.3134V20.1894C30.4238 20.4683 30.1978 20.6943 29.9189 20.6943ZM25.8998 19.6845H29.4141V17.8183H25.8998V19.6845Z",
    fill: "#F9F7F8"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9189 26.7353H25.395C25.1161 26.7353 24.8901 26.5093 24.8901 26.2304V23.3564C24.8901 23.0776 25.1162 22.8516 25.395 22.8516H29.9189C30.1978 22.8516 30.4238 23.0776 30.4238 23.3564V26.2304C30.4238 26.5093 30.1978 26.7353 29.9189 26.7353ZM25.8998 25.7256H29.4141V23.8612H25.8998V25.7256Z",
    fill: "#F9F7F8"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.354 4.04033H20.0349C20.9746 4.04033 21.2815 3.94657 21.2815 4.94161V7.43875V9.93968V29.0423H22.4245H23.1014V9.95883V8.39739V7.76978V5.89836V2.49805H10.354V4.04033Z",
    fill: "#DDDAEC"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5672 0H9.69785C9.0094 0 8.44556 0.562602 8.44556 1.24955C8.44556 1.9365 9.0094 2.4991 9.69785 2.4991H10.3537H23.1011H23.5671C24.2556 2.4991 24.8194 1.9365 24.8194 1.24955C24.8195 0.562536 24.2556 0 23.5672 0Z",
    fill: "#EB5468"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7473 0C22.4358 0 22.9996 0.562602 22.9996 1.24955C22.9996 1.9365 22.4358 2.4991 21.7473 2.4991H23.1013H23.5673C24.2558 2.4991 24.8196 1.9365 24.8196 1.24955C24.8196 0.562602 24.2558 0 23.5673 0H21.7473Z",
    fill: "#E5384F"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0249 21.3516H16.7266V29.0423H13.0249V21.3516Z",
    fill: "#B1E4F9"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7271 21.3516H20.43V29.0423H16.7271V21.3516Z",
    fill: "#B1E4F9"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0251 22.3867H15.664H16.7264V21.3516H13.0251V22.3867Z",
    fill: "#75CEF8"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7268 21.3516V22.3868H18.8939C19.4904 22.3868 19.3657 22.5628 19.3657 23.1904V29.042H20.43V21.3516H16.7268Z",
    fill: "#75CEF8"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M8.05765 14.6454H3.5356C3.25672 14.6454 3.03076 14.4194 3.03076 14.1406V11.2646C3.03076 10.9858 3.25678 10.7598 3.5356 10.7598H8.05765C8.33653 10.7598 8.56249 10.9858 8.56249 11.2646V14.1406C8.56249 14.4194 8.33653 14.6454 8.05765 14.6454ZM4.04044 13.6358H7.55281V11.7695H4.04044V13.6358Z",
    fill: "#F9F7F8"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M8.05838 20.6943H3.53633C3.25745 20.6943 3.03149 20.4683 3.03149 20.1894V17.3134C3.03149 17.0346 3.25751 16.8086 3.53633 16.8086H8.05838C8.33727 16.8086 8.56322 17.0346 8.56322 17.3134V20.1894C8.56322 20.4683 8.33727 20.6943 8.05838 20.6943ZM4.04117 19.6845H7.55354V17.8183H4.04117V19.6845Z",
    fill: "#F9F7F8"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M8.05863 26.7353H3.53658C3.25769 26.7353 3.03174 26.5093 3.03174 26.2304V23.3564C3.03174 23.0776 3.25776 22.8516 3.53658 22.8516H8.05863C8.33751 22.8516 8.56347 23.0776 8.56347 23.3564V26.2304C8.56347 26.5093 8.33751 26.7353 8.05863 26.7353ZM4.04142 25.7256H7.55379V23.8612H4.04142V25.7256Z",
    fill: "#F9F7F8"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9189 14.6454H25.395C25.1161 14.6454 24.8901 14.4194 24.8901 14.1406V11.2646C24.8901 10.9858 25.1162 10.7598 25.395 10.7598H29.9189C30.1978 10.7598 30.4238 10.9858 30.4238 11.2646V14.1406C30.4238 14.4194 30.1978 14.6454 29.9189 14.6454ZM25.8998 13.6358H29.4141V11.7695H25.8998V13.6358Z",
    fill: "#F9F7F8"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9347 21.3525V29.0432H19.925V21.8573H17.2317V29.0432H16.2219V21.8573H13.53V29.0432H12.5203V21.3525C12.5203 21.0738 12.7464 20.8477 13.0251 20.8477H20.4298C20.7086 20.8477 20.9347 21.0738 20.9347 21.3525Z",
    fill: "#375E7D"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7715 5.96875H15.6812C15.5815 5.96875 15.5009 6.05102 15.5009 6.15053V8.07364H13.5735C13.4719 8.07364 13.3914 8.15591 13.3914 8.25542V10.3412C13.3914 10.4407 13.4719 10.5211 13.5735 10.5211H15.5009V12.4461C15.5009 12.5456 15.5815 12.6259 15.6812 12.6259H17.7715C17.8713 12.6259 17.9537 12.5456 17.9537 12.4461V10.5211H19.8811C19.9808 10.5211 20.0633 10.4407 20.0633 10.3412V8.25542C20.0633 8.15591 19.9808 8.07364 19.8811 8.07364H17.9537V6.15053C17.9537 6.05108 17.8713 5.96875 17.7715 5.96875Z",
    fill: "#EB5468"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7713 5.96875H16.2505C16.5996 6.76097 16.8105 7.79044 16.8105 8.91362C16.8105 10.4502 16.4173 11.8069 15.8152 12.6258H17.7713C17.871 12.6258 17.9535 12.5454 17.9535 12.4459V10.5209H19.8808C19.9805 10.5209 20.063 10.4406 20.063 10.341V8.25529C20.063 8.15577 19.9805 8.07351 19.8808 8.07351H17.9535V6.1504C17.9535 6.05108 17.871 5.96875 17.7713 5.96875Z",
    fill: "#E5384F"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M18.861 15.7382H14.5939C14.3151 15.7382 14.0891 15.5122 14.0891 15.2334C14.0891 14.9545 14.3151 14.7285 14.5939 14.7285H18.861C19.1399 14.7285 19.3658 14.9545 19.3658 15.2334C19.3658 15.5122 19.1399 15.7382 18.861 15.7382Z",
    fill: "#60B7FF"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8612 18.123H14.5942C14.3153 18.123 14.0894 17.8969 14.0894 17.6181C14.0894 17.3393 14.3154 17.1133 14.5942 17.1133H18.8612C19.1401 17.1133 19.3661 17.3393 19.3661 17.6181C19.3661 17.8969 19.1401 18.123 18.8612 18.123Z",
    fill: "#60B7FF"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 7.14792C0 7.83298 0.558093 8.39172 1.2408 8.39747H1.2523H10.354V5.89844H1.2523C0.563843 5.89844 0 6.46097 0 7.14792H0Z",
    fill: "#EB5468"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.02466 5.89844V7.86166V8.39747H10.3537V7.76986V5.89844H9.02466Z",
    fill: "#E5384F"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup10);
export default __webpack_public_path__ + "static/media/Group10.de21dfee.svg";
export { ForwardRef as ReactComponent };